/**
 * @file Anchor Link.
 */
import { gsap } from 'gsap';

/**
 * Anchor Link component.
 */
const anchorLink = () => {
	const contact     = document.querySelector('.v-contact-cta');

	if (!contact) {
		return;
	}

	const anchorLinks  = document.querySelectorAll('.v-anchor-link');
	const contactMask  = contact.querySelector('.v-contact-cta__form');
	const contactInner = contact.querySelector('.v-contact-cta__form-inner');

	/**
	 * @param {Event} anchor - The clicked anchor event object.
	 */
	function scrollUser(anchor) {
		if (anchor.target.getAttribute('href').indexOf('#') !== 0) {
			return;
		}

		anchor.preventDefault();
		const contactForm   = document.querySelector(anchor.target.getAttribute('href'));
		const contactSelect = document.querySelector('[name="contact-regarding"]');

		gsap.to(window, {
			scrollTo:   contactForm.getBoundingClientRect().top + window.pageYOffset,
			duration:   0.5,
			ease:       'power3.easeInOut',
			onComplete: () => {
				contactForm.focus();
			},
		});

		if (contactSelect) {
			const conditionalB  = contact.querySelectorAll('[data-id^="business-"]');
			contactSelect.value = 'Business Products & Services';
			conditionalB.forEach((g) => g.classList.add('open'));

			gsap.to(contactMask, {
				duration:   0.5,
				height:     contactInner.getBoundingClientRect().height,
				onComplete: () => {
					contactMask.classList.add('open');
					contactMask.removeAttribute('style');
				},
			});
		}
	}

	[...anchorLinks].forEach((anchor) => {
		anchor.addEventListener('click', scrollUser);
	});
};

export default anchorLink;
